export default Object.freeze({
  // 権限
  AUTHORITY : [
    { value: 1, label: '全権限', isCorporate: true },
    { value: 2, label: 'システム管理', isCorporate: true },
    { value: 3, label: '管理ユーザ', isCorporate: true },
    { value: 9, label: '一般ユーザ',  isCorporate: true },
//    { value: 10, label: '問合せ仮ユーザ', isCorporate: false },
  ],

  // バリデーションメッセージ
  VALIDATION_MESSAGE : {
    required : '必須項目です。',
    email : 'メールアドレスの形式で入力してください。' ,
    numeric : '数値で入力してください。',
    integer : '整数値を入力してください。',
    sameAsMailAddress: 'メールアドレスが一致しません。',
    sameAsPassword: 'パスワードが一致しません。',
    checkPasswordStrength: 'パスワードは10文字以上としてください。\n大文字、小文字、数字、記号（#,$,@など）を含めてください。',
    maxLength: '文字までで入力してください。',
    url: '正しいURL形式で入力してください。',
    customAlphaNum: '半角英数字および「-」「_」のみで入力してください。',
    guideCodeValidate: 'ガイドコードには４桁の数字を入力してください。',
    between: '正しい範囲の数値を入力してください。',
    marketSelect : '市場に「上場」または「上場連結」を選択した場合、株式公開状況は必須です。',
    customDoubleNum : '正しい数値を入力してください。',
  },

  // 都道府県
  PREFS : [
    { value: "1",  label: '北海道' },
    { value: "2",  label: '青森県' },
    { value: "3",  label: '岩手県' },
    { value: "4",  label: '宮城県' },
    { value: "5",  label: '秋田県' },
    { value: "6",  label: '山形県' },
    { value: "7",  label: '福島県' },
    { value: "8",  label: '茨城県' },
    { value: "9",  label: '栃木県' },
    { value: "10", label: '群馬県' },
    { value: "11", label: '埼玉県' },
    { value: "12", label: '千葉県' },
    { value: "13", label: '東京都' },
    { value: "14", label: '神奈川県' },
    { value: "15", label: '新潟県' },
    { value: "16", label: '富山県' },
    { value: "17", label: '石川県' },
    { value: "18", label: '福井県' },
    { value: "19", label: '山梨県' },
    { value: "20", label: '長野県' },
    { value: "21", label: '岐阜県' },
    { value: "22", label: '静岡県' },
    { value: "23", label: '愛知県' },
    { value: "24", label: '三重県' },
    { value: "25", label: '滋賀県' },
    { value: "26", label: '京都府' },
    { value: "27", label: '大阪府' },
    { value: "28", label: '兵庫県' },
    { value: "29", label: '奈良県' },
    { value: "30", label: '和歌山県' },
    { value: "31", label: '鳥取県' },
    { value: "32", label: '島根県' },
    { value: "33", label: '岡山県' },
    { value: "34", label: '広島県' },
    { value: "35", label: '山口県' },
    { value: "36", label: '徳島県' },
    { value: "37", label: '香川県' },
    { value: "38", label: '愛媛県' },
    { value: "39", label: '高知県' },
    { value: "40", label: '福岡県' },
    { value: "41", label: '佐賀県' },
    { value: "42", label: '長崎県' },
    { value: "43", label: '熊本県' },
    { value: "44", label: '大分県' },
    { value: "45", label: '宮崎県' },
    { value: "46", label: '鹿児島県' },
    { value: "47", label: '沖縄県' },
  ],

  // 月
  MONTH_LIST : [
    { value: "1", label: '1月' },
    { value: "2", label: '2月' },
    { value: "3", label: '3月' },
    { value: "4", label: '4月' },
    { value: "5", label: '5月' },
    { value: "6", label: '6月' },
    { value: "7", label: '7月' },
    { value: "8", label: '8月' },
    { value: "9", label: '9月' },
    { value: "10", label: '10月' },
    { value: "11", label: '11月' },
    { value: "12", label: '12月' },
  ],

  // 日
  DAY_LIST : [
    { value: "1", label: '1日' },
    { value: "2", label: '2日' },
    { value: "3", label: '3日' },
    { value: "4", label: '4日' },
    { value: "5", label: '5日' },
    { value: "6", label: '6日' },
    { value: "7", label: '7日' },
    { value: "8", label: '8日' },
    { value: "9", label: '9日' },
    { value: "10", label: '10日' },
    { value: "11", label: '11日' },
    { value: "12", label: '12日' },
    { value: "13", label: '13日' },
    { value: "14", label: '14日' },
    { value: "15", label: '15日' },
    { value: "16", label: '16日' },
    { value: "17", label: '17日' },
    { value: "18", label: '18日' },
    { value: "19", label: '19日' },
    { value: "20", label: '20日' },
    { value: "21", label: '21日' },
    { value: "22", label: '22日' },
    { value: "23", label: '23日' },
    { value: "24", label: '24日' },
    { value: "25", label: '25日' },
    { value: "26", label: '26日' },
    { value: "27", label: '27日' },
    { value: "28", label: '28日' },
    { value: "29", label: '29日' },
    { value: "30", label: '30日' },
    { value: "31", label: '31日' },
  ],

  // 事業所チェックリストのセレクトボックス選択肢
  OFFICE_CHECK_LIST_VALUE : [
    { value: "1", label: '有り' },
    { value: "2", label: '無し' },
    { value: "3", label: '対象外' },
  ],

  // YES/NO
  BOOLEAN_VALUE : [
    { value: false, label: 'いいえ' },
    { value: true,  label: 'はい' },
  ],

  // 労務診断についてのお問い合わせを受信する
  INQ_MAIL_RECV_KBN_VALUE : [
    { value: 0, label: 'いいえ' },
    { value: 1,  label: 'はい' },
  ],

  // 診断の回答
  DIAG_ANSWER_VALUE : [
    { value: "1", label: 'はい' },
    { value: "2", label: 'いいえ' },
    { value: "3", label: '不明' },
    { value: "4", label: '対象外' },
  ],

  // 利用診断タイプ
  USE_DIAG_TYPE : [
    { value: 0, label: 'すべて' },
    { value: 1, label: '簡易のみ' },
    { value: 2, label: '詳細のみ' },
  ],

  // 法人利用区分
  USAGE_KBN : [
    { value: 1, label: '通常' },
    { value: 2, label: 'トライアル' },
  ],

  // お知らせ種類
  NOTICE_TYPE : [
    { value: 2, label: '法改正' },
    { value: 4, label: '判例' },
    { value: 5, label: '動向' },
    { value: 7, label: 'ガイドライン' },
    { value: 10, label: 'リーフレット' },
    { value: 8, label: '行政調査' },
    { value: 9, label: 'ソリューション' },
    { value: 3, label: '助成金' },
    { value: 1, label: '診断改定' },
    { value: 6, label: 'メンテナンス' },
    { value: 50, label: '事務所だより' },
    { value: 99, label: 'その他' },
  ],

  // メール送信区分
  MAIL_SEND_KBN : [
    { value: 0, label: '送信しない', shortLabel: '送信しない' },
    { value: 1, label: '送信する(予定)', shortLabel: '送信(予)' },
    { value: 2, label: '送信する(即時)', shortLabel: '送信(即)' },
  ],

  // メール送信対象
  MAIL_SEND_TARGET : [
    { value: 1, label: '専門家ユーザすべて' },
    { value: 2, label: '管理下の専門家ユーザすべて' },
    { value: 3, label: '一般ユーザすべて' },
    { value: 4, label: '管理下の一般ユーザすべて' },
    { value: 5, label: '専門家・一般ユーザすべて' },
  ],

  // 問合せステータスコード
  INQUIRY_STATUS_CODE : [
    { value: "1", label: '未回答' },
    { value: "2", label: '確認中' },
    { value: "9", label: '回答済' },
  ],

  // 問合せ区分
  INQUIRY_KBN : [
    { value: 1, label: '労務監査に関するお問い合わせ', shortLabel: '労務監査' },
    { value: 2, label: 'ソリューションに関するお問い合わせ', shortLabel: 'ソリューション' },
    { value: 3, label: 'システムに関するお問い合わせ', shortLabel: 'システム' },
  ],

  // 問合せフォームコンタクト区分
  CONTACT_TYPE : [
    { value: 1, label: 'トライアル申込' },
    { value: 2, label: 'お問い合わせ' },
  ],

  // 社労士診断項目確認状況
  VERIFIED_BY_LABOR_CONSULTANT : [
    { value: true,  label: '済' },
    { value: false, label: '未' },
  ],

  // 小診断の回答
  ROUGH_DIAG_ANSWER_VALUE : [
    { value: "1", label: 'はい' },
    { value: "2", label: 'いいえ' },
    //{ value: "3", label: '不明' },
    { value: "4", label: '対象外' },
  ],

  // 診断項マスタ: 選択パターン
  DIAG_SUB_SECTION_SELECT_PATTERN : [
    { value: "1", label: '1択' },
    { value: "4", label: '4択' },
  ],

  // 診断管理：一括更新
  DIAG_MANAGEMENT_BULK_UPDATE_MODE : [
    { value: "1", label: '確認済に変更' },
    { value: "2", label: '優先度を高に' },
    { value: "3", label: '回答を「はい」に変更' },
    { value: "4", label: '回答を「いいえ」に変更' },
    { value: "5", label: '回答を「不明」に変更' },
    { value: "6", label: '回答を「対象外」に変更' },
  ],

  // 企業規模
  COMPANY_SCALE_TYPE : [
    { value: "1", label: '大企業' },
    { value: "2", label: '中小企業' },
  ],

  //主たる業種
  MAIN_INDUSTRY_TYPE : [
    { value: "1", label: '農林水産' },
    { value: "2", label: '鉱業' },
    { value: "3", label: '建設業' },
    { value: "4", label: '製造業' },
    { value: "5", label: '電気・ガス' },
    { value: "6", label: '運送業' },
    { value: "7", label: '情報通信業' },
    { value: "8", label: '卸売業' },
    { value: "9", label: '小売業' },
    { value: "10", label: '飲食業' },
    { value: "11", label: '金融・保険業' },
    { value: "12", label: '不動産業' },
    { value: "13", label: 'サービス業' },
    { value: "14", label: '医療業' },
    { value: "15", label: '福祉業' },
  ],

  //業種大項目
  INDUSTORY_ITEM : [
    { value: "0", label: '農業，林業' },
    { value: "1", label: '漁業' },
    { value: "2", label: '鉱業，採石業，砂利採取業' },
    { value: "3", label: '建設業' },
    { value: "4", label: '製造業' },
    { value: "5", label: '電気・ガス・熱供給・水道業' },
    { value: "6", label: '情報通信業' },
    { value: "7", label: '運輸業，郵便業' },
    { value: "8", label: '卸売業，小売業' },
    { value: "9", label: '金融業，保険業' },
    { value: "10", label: '不動産業，物品賃貸業' },
    { value: "11", label: '学術研究，専門・技術サービス業' },
    { value: "12", label: '宿泊業，飲食サービス業' },
    { value: "13", label: '生活関連サービス業，娯楽業' },
    { value: "14", label: '教育，学習支援業' },
    { value: "15", label: '医療，福祉' },
    { value: "16", label: '複合サービス事業' },
    { value: "17", label: 'サービス業（他に分類されないもの）' },
    { value: "18", label: '公務（他に分類されるものを除く）' },
    { value: "19", label: '分類不能の産業' },
  ],
  //業種中項目
  INDUSTORY_SUBITEM : [
      {options: [
      { value: "1", label: '農業' },
      { value: "2", label: '林業' },
      ]},
    { options: [
      { value: "3", label: '漁業（水産養殖業を除く）' },
      { value: "4", label: '水産養殖業' },
    ]},
    { options: [
      { value: "5", label: '鉱業，採石業，砂利採取業' },
    ]},
    { options: [
      { value: "6", label: '総合工事業' },
      { value: "7", label: '職別工事業(設備工事業を除く)' },
      { value: "8", label: '設備工事業' },
    ]},
    { options: [
      { value: "9", label: '食料品製造業' },
      { value: "10", label: '飲料・たばこ・飼料製造業' },
      { value: "11", label: '繊維工業' },
      { value: "12", label: '木材・木製品製造業（家具を除く）' },
      { value: "13", label: '家具・装備品製造業' },
      { value: "14", label: 'パルプ・紙・紙加工品製造業' },
      { value: "15", label: '印刷・同関連業' },
      { value: "16", label: '化学工業' },
      { value: "17", label: '石油製品・石炭製品製造業' },
      { value: "18", label: 'プラスチック製品製造業（別掲を除く）' },
      { value: "19", label: 'ゴム製品製造業' },
      { value: "20", label: 'なめし革・同製品・毛皮製造業' },
      { value: "21", label: '窯業・土石製品製造業' },
      { value: "22", label: '鉄鋼業' },
      { value: "23", label: '非鉄金属製造業' },
      { value: "24", label: '金属製品製造業' },
      { value: "25", label: 'はん用機械器具製造業' },
      { value: "26", label: '生産用機械器具製造業' },
      { value: "27", label: '業務用機械器具製造業' },
      { value: "28", label: '電子部品・デバイス・電子回路製造業' },
      { value: "29", label: '電気機械器具製造業' },
      { value: "30", label: '情報通信機械器具製造業' },
      { value: "31", label: '輸送用機械器具製造業' },
      { value: "32", label: 'その他の製造業' },
    ]},
    { options: [
      { value: "33", label: '電気業' },
      { value: "34", label: 'ガス業' },
      { value: "35", label: '熱供給業' },
      { value: "36", label: '水道業' },
    ]},
    { options: [
      { value: "37", label: '通信業' },
      { value: "38", label: '放送業' },
      { value: "39", label: '情報サービス業' },
      { value: "40", label: 'インターネット附随サービス業' },
      { value: "41", label: '映像・音声・文字情報制作業' },
    ]},
    { options: [
      { value: "42", label: '鉄道業' },
      { value: "43", label: '道路旅客運送業' },
      { value: "44", label: '道路貨物運送業' },
      { value: "45", label: '水運業' },
      { value: "46", label: '航空運輸業' },
      { value: "47", label: '倉庫業' },
      { value: "48", label: '運輸に附帯するサービス業' },
      { value: "49", label: '郵便業（信書便事業を含む）' },
    ]},
    { options: [
      { value: "50", label: '各種商品卸売業' },
      { value: "51", label: '繊維・衣服等卸売業' },
      { value: "52", label: '飲食料品卸売業' },
      { value: "53", label: '建築材料，鉱物・金属材料等卸売業' },
      { value: "54", label: '機械器具卸売業' },
      { value: "55", label: 'その他の卸売業' },
      { value: "56", label: '各種商品小売業' },
      { value: "57", label: '織物・衣服・身の回り品小売業' },
      { value: "58", label: '飲食料品小売業' },
      { value: "59", label: '機械器具小売業' },
      { value: "60", label: 'その他の小売業' },
      { value: "61", label: '無店舗小売業' },
    ]},
    { options: [
      { value: "62", label: '銀行業' },
      { value: "63", label: '協同組織金融業' },
      { value: "64", label: '貸金業，クレジットカード業等非預金信用機関' },
      { value: "65", label: '金融商品取引業，商品先物取引業' },
      { value: "66", label: '補助的金融業等' },
      { value: "67", label: '保険業（保険媒介代理業，保険サービス業を含む）' },
    ]},
    { options: [
      { value: "68", label: '不動産取引業' },
      { value: "69", label: '不動産賃貸業・管理業' },
      { value: "70", label: '物品賃貸業' },
    ]},
    { options: [
      { value: "71", label: '学術・開発研究機関' },
      { value: "72", label: '専門サービス業（他に分類されないもの）' },
      { value: "73", label: '広告業' },
      { value: "74", label: '技術サービス業（他に分類されないもの）' },
    ]},
    { options: [
      { value: "75", label: '宿泊業' },
      { value: "76", label: '飲食店' },
      { value: "77", label: '持ち帰り・配達飲食サービス業' },
    ]},
    { options: [
      { value: "78", label: '洗濯・理容・美容・浴場業' },
      { value: "79", label: 'その他の生活関連サービス業' },
      { value: "80", label: '娯楽業' },
    ]},
    { options: [
      { value: "81", label: '学校教育' },
      { value: "82", label: 'その他の教育，学習支援業' },
    ]},
    { options: [
      { value: "83", label: '医療業' },
      { value: "84", label: '保健衛生' },
      { value: "85", label: '社会保険・社会福祉・介護事業' },
    ]},
    { options: [
      { value: "86", label: '郵便局' },
      { value: "87", label: '協同組合（他に分類されないもの）' },
    ]},
    { options: [
      { value: "88", label: '廃棄物処理業' },
      { value: "89", label: '自動車整備業' },
      { value: "90", label: '機械等修理業（別掲を除く）' },
      { value: "91", label: '職業紹介・労働者派遣業' },
      { value: "92", label: 'その他の事業サービス業' },
      { value: "93", label: '政治・経済・文化団体' },
      { value: "94", label: '宗教' },
      { value: "95", label: 'その他のサービス業' },
      { value: "96", label: '外国公務' },
    ]},
    { options: [
      { value: "97", label: '国家公務' },
      { value: "98", label: '地方公務' },
    ]},
    { options: [
      { value: "99", label: '分類不能の産業' },
    ]},
  ],

  // 市場
  MARKET_TYPE : [
    { value: "1", label: '上場' },
    { value: "2", label: '上場連結' },
    { value: "3", label: '非上場' },
  ],
  MARKET_SUB_TYPE : [
    { value: "1", label: 'プライム市場' },
    { value: "2", label: 'スタンダード市場' },
    { value: "3", label: 'グロース市場' },
    { value: "4", label: 'TOKYO PRO Market' },
    { value: "99", label: 'その他' },
  ],

  // 従業員数
  EMPLOYEE_NUMBER_TYPE : [
    { value: "1", label: '10名未満' },
    { value: "2", label: '10名以上50名未満' },
    { value: "3", label: '50名以上100名未満' },
    { value: "4", label: '100名以上300名未満' },
    { value: "5", label: '300名以上500名未満' },
    { value: "6", label: '500名以上1000名未満' },
    { value: "7", label: '1000名以上' },
    { value: "8", label: 'その他' },
  ],

  // 小テストマスタ登録
  ROUGH_DIAG_TAIOU_DISP_TYPE : [
    { value: "2", label: "回答が「いいえ」の場合に表示"},
    { value: "1", label: "回答が「はい」の場合に表示"},
  ],

  // 人的資本項目
  HUMAN_CAPITAL_ITEM : [
    { value: "1",  label: '採用女性労働者割合' },
    { value: "2",  label: '平均継続勤務年数' },
    { value: "3",  label: '離職率' },
    { value: "4",  label: '女性管理職比率' },
    { value: "5",  label: '平均年齢' },
    { value: "6",  label: '障がい者雇用率' },
    { value: "7",  label: '高年齢者雇用率' },
    { value: "8",  label: '労災発生件数' },
    { value: "9",  label: '年次有給休暇取得率' },
    { value: "10", label: '1月あたりの平均残業時間' },
    { value: "11", label: '育児休業取得率' },
    { value: "12", label: '介護休業・短時間勤務取得者数' },
    { value: "13", label: '年間平均賃金' },
    { value: "14", label: '財務情報' },
  ],
  // 遷移リスト
  TRANSITION_LIST: [
    '',
    'female_percentage',
    'employment_year',
    'turnover',
    'female_manager',
    'age_average',
    'disabilities_rate',
    'elderly_rate',
    'accidents_count',
    'acquisition_rate',
    'working_average',
    'childcare_rate',
    'nursing_care',
    'wage_average',
    'financial'
  ],
})
